<template>
  <div class="relative flex bg-gray-900 rounded-2xl p-2 mt-3 overflow-hidden">
    <img class="h-16 self-center" :src="product.imgurl"
         @error="$event.target.src = require('@/assets/img/placeholder.png')">
    <div class="p-2 w-full text-gray-400 text-sm">
      <!-- Name -->
      <h1 class="text-white text-sm">{{ product.kala_Name }}</h1>
      <!-- Price -->
      <h5 class="mt-3">
        قیمت:
        <i v-if="isNegative">-</i>{{
          $helper.priceFormatter(product.nerkh_With_Maliat)
        }}
      </h5>
      <hr class="my-2 border-yellow-300">
      <!-- Total Price-->
      <div class="font-bold">
        جمع:
        <span :class="isNegative ? 'text-red-500' : 'text-green-500'">
                <i v-if="isNegative">-</i>{{
            $helper.priceFormatter(productPrice)
          }}
        </span>
      </div>
      <!-- Takeout Control-->
      <div class="flex justify-between items-center mt-2 text-center" v-if="!isNegative">
        بیرون بر:
        <div class="flex items-center bg-gray-500 rounded-lg text-white p-0.5">
          <span class="px-2" @click="incrementTakeout">+</span>
          <span>{{ takeoutCount }}</span>
          <span class="px-2" @click="decrementTakeout">-</span>
        </div>
      </div>
    </div>
    <!-- Product Ordered Quantity -->
    <div class="absolute text-white left-0 -top-0.5 bg-yellow-500 py-2 px-3 rounded-br-2xl text-sm">{{
        product.quantity
      }}
    </div>
  </div>

</template>
<script>
export default {
  name: 'ReceiptProductCard',
  props: ['product'],
  computed: {
    isNegative() {
      return this.product.nerkh * this.product.isNegative < 0
    },
    productPrice() {
      return this.product.quantity * this.product.nerkh_With_Maliat
    },
    takeoutCount() {
      return this.$store.getters.takeoutCount(this.product.kala)
    }
  },
  methods: {
    incrementTakeout() {
      this.$store.dispatch('incrementTakeout', this.product)
          .catch(err => {
            this.$swal({
              icon: 'error',
              title: 'خطا',
              text: err,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
          })
    },
    decrementTakeout() {
      this.$store.dispatch('decrementTakeout', this.product)
    },
  }
}
</script>
